import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
import { createRef } from "react";
import { UserReviewCards } from "./userReviewCard";
import { SilderContainer, RailWrapper, Container } from "./index.styled";
import { GoToPrev, GoToNext } from "../featured-show-rail/nav-button";
const scrollableRail = createRef();
export const DesktopView = ({ userReviews, }) => {
    const [isLeftArrowVisible, setLeftArrow] = useState(false);
    const [isRightArrowVisible, setRighttArrow] = useState(false);
    const [width, setRailClientWidth] = useState(400);
    const rail = scrollableRail.current;
    const checkArrow = () => {
        const rail = scrollableRail.current;
        if (rail) {
            setLeftArrow(rail.scrollLeft > 0 ? true : false);
            setRighttArrow(rail.scrollWidth > rail.clientWidth &&
                rail.scrollWidth - rail.scrollLeft > rail.clientWidth
                ? true
                : false);
        }
    };
    const onLeftClick = () => {
        if (scrollableRail.current) {
            rail === null || rail === void 0 ? void 0 : rail.scrollTo({
                left: rail.scrollLeft - rail.clientWidth,
                behavior: "smooth",
            });
        }
    };
    const onRightClick = () => {
        if (scrollableRail.current) {
            rail === null || rail === void 0 ? void 0 : rail.scrollTo({
                left: rail.scrollLeft + rail.clientWidth,
                behavior: "smooth",
            });
        }
    };
    useEffect(() => {
        const rail = scrollableRail.current;
        const width = rail && rail.clientWidth ? (rail.clientWidth - 60) / 3 : 400;
        rail === null || rail === void 0 ? void 0 : rail.addEventListener("scroll", checkArrow);
        checkArrow();
        setRailClientWidth(width);
        return () => {
            rail === null || rail === void 0 ? void 0 : rail.removeEventListener("scroll", checkArrow);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rail]);
    return (React.createElement(Container, null,
        isLeftArrowVisible && (React.createElement(GoToPrev, { onClick: onLeftClick, className: "goToPrev" })),
        isRightArrowVisible && (React.createElement(GoToNext, { onClick: onRightClick, className: "goToNext" })),
        React.createElement(RailWrapper, { ref: scrollableRail },
            React.createElement(SilderContainer, null,
                React.createElement(UserReviewCards, { userReviews: userReviews, width: width })))));
};

